import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getUserPost = async (ids: any[]) => {
  if (!ids.length) {
    return []
  }

  const { data, error } = await supabase
    .from('posts')
    .select(`
    *,
    category:categories(*),
    profile:user_profiles (id, username),
    assetPrices:posts_assets (price_time_posting, asset_id),
    hashtags:hashtags(*),
    assets:assets!posts_assets (
      *,
      category:categories(*)
      ),
      series:series(*)
      `)
    .in('id', ids);

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useUserPosts(ids: any[]) {
  return useQuery({
    queryKey: ['useUserPosts', ids],
    queryFn: () => getUserPost(ids),
    enabled: Boolean(ids),
    staleTime: 60000,
  })
}
